import { DescriptionList } from "@/lib/Components/DescriptionList/DescriptionListCard";
import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { useOrganisationRecord } from "@/app/Organisations/Hooks/useOrganisationRecord";
import { TimeSinceNow } from "@/lib/Components/Common/TimeSinceNow";
import { Badge } from "@/components/catalyst/badge";

export function OrganisationDetailsScreen() {
  const record = useOrganisationRecord();

  return (
    <div className="space-y-6 py-6">
      <RecordScreenCard title="Organisation details">
        <DescriptionList
          items={[
            {
              key: "Name",
              value: record.name,
            },
            {
              key: "Verified",
              value: record.is_verified ? (
                <Badge color="green">Yes</Badge>
              ) : (
                <Badge color="zinc">No</Badge>
              ),
            },
            {
              key: "Sales agent",
              value: record.salesAgent?.name ?? "--",
            },
            {
              key: "Created",
              value: record.created_at ? (
                <TimeSinceNow time={record.created_at} />
              ) : (
                "--"
              ),
            },
            {
              key: "Updated",
              value: record.updated_at ? (
                <TimeSinceNow time={record.updated_at} />
              ) : (
                "--"
              ),
            },
          ]}
        />
      </RecordScreenCard>

      {record.featureFlags.length > 0 ? (
        <RecordScreenCard title="Feature flags">
          <div className="flex flex-wrap gap-2">
            {record.featureFlags.map((flag) => (
              <Badge key={flag.type} color="indigo">
                {flag.type}
              </Badge>
            ))}
          </div>
        </RecordScreenCard>
      ) : null}
    </div>
  );
}
